'use client'

import { NotFound as NotFoundScreen } from '@/screens/NotFound'

import type { CatalogItem } from '@/entities/catalog/types'

type Props = {
	catalogItems: CatalogItem[]
}

export const NotFoundContentClient = ({ catalogItems }: Props) => {
	return <NotFoundScreen title="404. Страница не найдена" catalogItems={catalogItems} />
}
